/* erzeugt aus preview/ (shop-port.js) */
/* OTHERSPORTS · Dark Premium – Bewegungs-Extras: Wort-Einblendung, Zähler, Parallax
   (Scroll-Reveal, Tabs, Navigation bleiben in main.js.) */
(function () {
  'use strict';
  var doc = document;
  var motion = !doc.documentElement.classList.contains('no-motion') && new URLSearchParams(location.search).get('motion') !== '0';

  /* Überschriften Wort für Wort einblenden */
  // data-no-words: Überschriften mit eigenem Zeilenaufbau (z. B. feste Umbruchstelle) bleiben unzerlegt
  var heads = Array.prototype.slice.call(doc.querySelectorAll('.os-words, .os-dark main .os-head .os-h2:not([data-no-words])'));
  heads.forEach(function (el) {
    el.classList.add('os-words');
    el.removeAttribute('data-reveal');
    var text = el.textContent.trim();
    el.setAttribute('aria-label', text);
    el.innerHTML = text.split(/\s+/).map(function (w, i) { return '<span class="w" aria-hidden="true"><span style="--i:' + i + '">' + w + '</span></span>'; }).join(' ');
    if (!motion) el.classList.add('is-in');
  });
  function sweep() {
    var vh = window.innerHeight;
    heads.forEach(function (el) { if (!el.classList.contains('is-in') && el.getBoundingClientRect().top < vh * 0.9) el.classList.add('is-in'); });
  }
  window.setTimeout(function () { var h1 = doc.querySelector('.os-hero .os-words'); if (h1) h1.classList.add('is-in'); sweep(); }, 120);

  /* Zahlen zählen hoch, sobald sie sichtbar werden */
  var counters = Array.prototype.slice.call(doc.querySelectorAll('[data-count]'));
  function runCounter(el) {
    if (el.getAttribute('data-done')) return;
    el.setAttribute('data-done', '1');
    var end = Number(el.getAttribute('data-count')), pre = el.getAttribute('data-pre') || '', suf = el.getAttribute('data-suf') || '';
    if (!motion) { el.textContent = pre + end + suf; return; }
    var t0 = performance.now();
    (function step(t) {
      var p = Math.min(1, (t - t0) / 1400);
      el.textContent = pre + Math.round(end * (1 - Math.pow(1 - p, 3))) + suf;
      if (p < 1) requestAnimationFrame(step);
    })(t0);
  }

  /* Parallax */
  var par = Array.prototype.slice.call(doc.querySelectorAll('[data-parallax]'));
  var ticking = false;
  function frame() {
    ticking = false;
    var vh = window.innerHeight;
    sweep();
    counters.forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < vh * 0.9 && r.bottom > 0) runCounter(el); });
    if (!motion) return;
    par.forEach(function (el) {
      var r = el.parentElement.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var p = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.transform = 'translate3d(0,' + (p * -Number(el.getAttribute('data-parallax') || 60)).toFixed(1) + 'px,0)';
    });
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
  window.addEventListener('resize', frame);
  frame();
})();

/* Header: liegt frei über dem Hero und wird erst beim Scrollen (oder bei offenem Mobil-Menü) dunkel */
(function () {
  var header = document.getElementById('os-header');
  if (!header) return;
  var nav = document.getElementById('os-mobile-nav');
  function solid() { header.classList.toggle('is-solid', window.scrollY > 24); }
  window.addEventListener('scroll', solid, { passive: true });
  solid();
  if (nav && 'MutationObserver' in window) {
    new MutationObserver(function () { header.classList.toggle('is-menu', !nav.hidden); }).observe(nav, { attributes: true, attributeFilter: ['hidden'] });
  }
})();

/* Mockups: Der Inhalt hat eine feste Entwurfsgröße und wird auf die Bildschirmfläche im Foto skaliert
   (iPad-Szene: 780 px breit · Smartphone: 300 px breit). */
(function () {
  var pairs = [['.os-tw__scene .os-tw__shell', 640, 454, '--tw-s'], ['.os-phone__screen', 300, 658, '--ph-s']];
  function fit() {
    pairs.forEach(function (p) {
      var el = document.querySelector(p[0]);
      if (!el || !el.clientWidth) return;
      var cs = getComputedStyle(el);
      var b = el.clientWidth - parseFloat(cs.paddingLeft || 0) - parseFloat(cs.paddingRight || 0);
      var hoch = el.clientHeight - parseFloat(cs.paddingTop || 0) - parseFloat(cs.paddingBottom || 0);
      var s = Math.min(b / p[1], hoch / p[2]);
      el.style.setProperty(p[3], s.toFixed(4));
    });
  }
  fit();
  window.addEventListener('resize', fit);
  window.addEventListener('load', fit);
  window.requestAnimationFrame(fit);
  window.setTimeout(fit, 250);
  document.querySelectorAll('.os-tw__geraet, .os-phone__hand').forEach(function (b) { b.addEventListener('load', fit); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  if ('ResizeObserver' in window) {
    pairs.forEach(function (p) { var el = document.querySelector(p[0]); if (el) { new ResizeObserver(fit).observe(el); if (el.parentElement) new ResizeObserver(fit).observe(el.parentElement); } });
  }
})();

/* Hero-Bewegtbild: zwei Clips im Wechsel (oben→unten, unten→oben) ergeben ein Kreuzheben über den vollen Weg.
   KI-Clips stehen am Anfang und Ende oft einige Zehntel still – das ergäbe unten einen „Stopp“. Deshalb:
   – Startversatz über das Medienfragment in der URL (…mp4#t=0.4), gilt auch nach jedem load()
   – Endpunkt über data-bis (Sekunden): dort wird auf den nächsten Clip gewechselt, nicht erst bei „ended“
   Der nächste Clip wird erst eingeblendet, wenn er wirklich läuft – so gibt es kein Aufblitzen.
   ?hero=bild zeigt nur das Standbild. */
(function () {
  var clips = Array.prototype.slice.call(document.querySelectorAll('[data-hero-seq]'));
  var wahl = new URLSearchParams(location.search).get('hero');
  var still = wahl === 'bild' || document.documentElement.classList.contains('no-motion');
  if (still) { document.querySelectorAll('.os-hero__video').forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); v.removeAttribute('src'); v.load(); }); return; }
  if (clips.length < 2) return;
  function weiter(v, i) {
    if (v._fertig) return;
    v._fertig = true;
    var next = clips[(i + 1) % clips.length];
    // Der beendete Clip wird nach dem Wechsel per load() zurückgesetzt (kein currentTime-Sprung: der kann in Hintergrund-Tabs hängen bleiben)
    var show = function () { next.removeEventListener('playing', show); next.classList.remove('is-off'); v.classList.add('is-off'); v.pause(); v.load(); v._fertig = false; };
    next.addEventListener('playing', show);
    next.play().catch(function () {});
  }
  clips.forEach(function (v, i) {
    v.loop = false;
    v.autoplay = false; // sonst startet load() den beendeten Clip im Hintergrund sofort neu
    var bis = parseFloat(v.getAttribute('data-bis')) || Infinity;
    v.addEventListener('ended', function () { weiter(v, i); });
    (function tick() { if (!v.paused && v.currentTime >= bis) weiter(v, i); requestAnimationFrame(tick); })();
  });
  clips[0].play().catch(function () {});
  // Browser pausieren stumme Videos in Hintergrund-Tabs von selbst – beim Zurückkehren läuft der sichtbare Clip weiter
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    var aktiv = clips.filter(function (v) { return !v.classList.contains('is-off'); })[0] || clips[0];
    if (aktiv.paused) aktiv.play().catch(function () {});
  });
})();

/* Produktkarten (Ronny, 20.09.2026 + 17.10.2026 + 18.10.2026):
   Desktop: nur wenn die Maus auf der Karte liegt, dreht sie sich und zeigt die Übungsbilder nacheinander;
   geht die Maus weg, dreht sie sofort zurück auf das Produktbild.
   Mobil (Wisch-Reihe): die Karte im Blick wechselt von selbst DURCHGEHEND – Übung 1, 2, 3, Produktbild, wieder
   von vorn –, solange die Reihe sichtbar ist. Die erste Karte startet sofort, nach dem Wischen beginnt die neue
   Karte nach einer Sekunde (Ronny 20.10.: vorher zwei, das wirkte zu träge). Ist die Reihe nicht mehr im Bild, ruht alles. */
(function () {
  var karten = Array.prototype.slice.call(document.querySelectorAll('[data-flip]'));
  if (!karten.length || document.documentElement.classList.contains('no-motion')) return;
  var reihe = karten[0].closest('ul');
  var istSlider = function () { return !!reihe && reihe.scrollWidth > reihe.clientWidth + 8; };
  var eintraege = karten.map(function (k) {
    var bilder = Array.prototype.slice.call(k.querySelectorAll('.os-product__back img'));
    var karte = k.closest('li') || k, takt = null, i = 0;
    function zeige(n) { bilder.forEach(function (b, m) { b.classList.toggle('is-on', m === n); }); }
    function an(mitProdukt) {
      if (takt || !bilder.length) return;
      i = 0; zeige(0); k.classList.add('is-flipped');
      takt = window.setInterval(function () {
        i += 1;
        if (i >= bilder.length + (mitProdukt ? 1 : 0)) i = 0;
        if (i === bilder.length) { k.classList.remove('is-flipped'); return; }   // nur mobil: kurz das Produktbild
        k.classList.add('is-flipped'); zeige(i);
      }, 1600);
    }
    function aus() { window.clearInterval(takt); takt = null; k.classList.remove('is-flipped'); }
    karte.addEventListener('pointerenter', function (ev) { if (ev.pointerType !== 'touch' && !istSlider()) an(false); });
    karte.addEventListener('pointerleave', function () { if (!istSlider()) aus(); });
    karte.addEventListener('focusin', function () { if (!istSlider()) an(false); });
    karte.addEventListener('focusout', function () { if (!istSlider()) aus(); });
    return { karte: karte, an: an, aus: aus };
  });
  if (!reihe) return;
  var warte, imBlick = null;
  function ruhe() { window.clearTimeout(warte); eintraege.forEach(function (e) { e.aus(); }); imBlick = null; }
  function pruefe() {
    if (!istSlider()) return;
    var r = reihe.getBoundingClientRect();
    var sichtbar = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
    if (sichtbar < r.height * 0.55) { if (imBlick) ruhe(); return; }
    var mitte = r.left + reihe.clientWidth / 2, best = null, d = 1e9;
    eintraege.forEach(function (e) { var b = e.karte.getBoundingClientRect(), x = Math.abs(b.left + b.width / 2 - mitte); if (x < d) { d = x; best = e; } });
    if (reihe.scrollLeft < 10) best = eintraege[0];            // ungewischt gilt die erste Karte
    if (!best || best === imBlick) return;
    var sofort = !imBlick && best === eintraege[0] && reihe.scrollLeft < 10;
    eintraege.forEach(function (e) { if (e !== best) e.aus(); });
    imBlick = best;
    window.clearTimeout(warte);
    warte = window.setTimeout(function () { if (imBlick === best) best.an(true); }, sofort ? 300 : 1000);
  }
  var t; function spaeter() { window.clearTimeout(t); t = window.setTimeout(pruefe, 160); }
  window.addEventListener('scroll', spaeter, { passive: true });
  reihe.addEventListener('scroll', spaeter, { passive: true });
  window.addEventListener('resize', spaeter);
  document.addEventListener('visibilitychange', function () { if (document.hidden) ruhe(); else spaeter(); });
  pruefe();
})();

/* Videos in Kartenreihen ([data-seq]) – bewusst ZURÜCKHALTEND (Ronny, 20.09.2026):
   Desktop: das Video startet NUR, wenn die Maus über der Karte liegt, läuft einmal durch und geht danach
   wieder auf das Standbild. Kein Dauerlauf, keine Fortschrittsleiste, keine hervorgehobene Karte.
   Mobil (Wisch-Reihe): die Karte, die gerade im Blick ist, startet nach gut einer Sekunde von selbst,
   läuft einmal und hört wieder auf. Beim Wischen startet die neue Karte genauso. */
(function () {
  if (document.documentElement.classList.contains('no-motion')) return;
  var gruppen = {};
  document.querySelectorAll('video[data-seq]').forEach(function (v) {
    (gruppen[v.getAttribute('data-seq')] = gruppen[v.getAttribute('data-seq')] || []).push(v);
  });

  function zeige(v) {
    if (v._laeuft) return;
    v._laeuft = true;
    var an = function () { v.removeEventListener('playing', an); v.classList.add('is-live'); };
    v.addEventListener('playing', an);
    v.load();                                  // zurück auf den Anfang, ohne currentTime-Sprung
    v.play().catch(function () {});
  }
  function verstecke(v) {
    v._laeuft = false;
    v.classList.remove('is-live');
    v.pause();
    window.setTimeout(function () { if (!v._laeuft) v.load(); }, 560);   // erst nach dem Ausblenden (0,5 s) zurücksetzen
  }

  Object.keys(gruppen).forEach(function (name) {
    var vids = gruppen[name], reihe = vids[0].closest('ul');
    var istSlider = function () { return reihe.scrollWidth > reihe.clientWidth + 8; };

    vids.forEach(function (v) {
      var karte = v.closest('li');
      v.addEventListener('ended', function () { verstecke(v); });          // einmal durchlaufen, dann Standbild
      karte.addEventListener('pointerenter', function (ev) {
        if (ev.pointerType === 'touch' || istSlider()) return;
        zeige(v);
      });
      karte.addEventListener('pointerleave', function () { if (!istSlider()) verstecke(v); });
      karte.addEventListener('focusin', function () { if (!istSlider()) zeige(v); });
      karte.addEventListener('focusout', function () { if (!istSlider()) verstecke(v); });
    });

    /* Mobil: nur die Karte in der Mitte der Reihe, mit kurzer Verzögerung nach dem Wischen */
    var warte;
    function pruefe() {
      if (!istSlider()) return;
      var r = reihe.getBoundingClientRect();
      if (r.top > window.innerHeight * .85 || r.bottom < window.innerHeight * .15) return;
      var mitte = r.left + reihe.clientWidth / 2, best = null, d = 1e9;
      vids.forEach(function (v) { var b = v.closest('li').getBoundingClientRect(), x = Math.abs(b.left + b.width / 2 - mitte); if (x < d) { d = x; best = v; } });
      if (!best || best === reihe._imBlick) return;
      reihe._imBlick = best;
      vids.forEach(function (o) { if (o !== best) verstecke(o); });
      window.clearTimeout(warte);
      warte = window.setTimeout(function () { if (reihe._imBlick === best) zeige(best); }, 1100);
    }
    var t; function spaeter() { window.clearTimeout(t); t = window.setTimeout(pruefe, 160); }
    window.addEventListener('scroll', spaeter, { passive: true });
    reihe.addEventListener('scroll', spaeter, { passive: true });
    window.addEventListener('resize', spaeter);
    pruefe();
  });
})();

/* Ablauf-Linien in der Trainingswelt: alle gleich lang (Restbreite durch vier) */
(function () {
  var flow = document.querySelector('.os-flow');
  if (!flow) return;
  function messe() {
    var lis = flow.querySelectorAll('li'), summe = 0;
    lis.forEach(function (li) { summe += li.getBoundingClientRect().width; });
    var frei = flow.clientWidth - summe - 14 * 8;
    flow.style.setProperty('--flow-linie', Math.max(12, Math.floor(frei / 4)) + 'px');
  }
  messe(); window.addEventListener('resize', messe); window.addEventListener('load', messe);
})();

/* Fitness-Check im Smartphone: Start → Frage → Übung → Auswertung → Ergebnis.
   Eine rechte Hand tippt jeden Schritt an. Überarbeitet am 20.09.2026 nach Ronnys Feedback:
   – Die Hand löst sich NIE auf. Wenn sie nicht tippt, fährt sie an den unteren Bildrand und bleibt dort halb sichtbar.
   – Es wird erst weitergeschaltet, wenn wirklich getippt wurde: auf ein fehlendes Ziel wird kurz gewartet.
   – Die Fahrt ist länger und weicher, das Drücken kurz und deutlich. */
(function () {
  var demo = document.querySelector('[data-check-demo]');
  if (!demo) return;
  var phone = demo.closest('.os-phone'), hand = phone.querySelector('[data-check-hand]');
  var views = {}; demo.querySelectorAll('[data-check-view]').forEach(function (v) { views[v.getAttribute('data-check-view')] = v; });
  var dots = demo.querySelectorAll('.os-phone__dots i'), sek = demo.querySelector('[data-check-sek]');
  function zeige(name, schritt) {
    Object.keys(views).forEach(function (k) { views[k].classList.toggle('is-on', k === name); });
    dots.forEach(function (d, i) { d.classList.toggle('is-on', i <= schritt); });
  }
  if (document.documentElement.classList.contains('no-motion')) { zeige('ergebnis', 2); return; }

  var TIP = { x: 0.12, y: 0.025 };               // Fingerspitze im Handbild (Anteil von Breite/Höhe)
  var warte = function (ms) { return new Promise(function (r) { window.setTimeout(r, ms); }); };

  function setze(x, y) { hand.style.setProperty('--hx', x + 'px'); hand.style.setProperty('--hy', y + 'px'); }
  /* Ruheplatz: unten rechts, die Hand ragt zur Hälfte aus dem Bildschirm – sichtbar, aber aus dem Weg */
  function ruhe() {
    if (!hand) return;
    setze(phone.clientWidth * 0.46, phone.clientHeight * 0.74);
    hand.classList.add('is-on');
  }
  /* Wartet, bis das Ziel wirklich da und sichtbar ist – sonst würde ein Tipp verschluckt */
  async function hole(name) {
    for (var i = 0; i < 24; i++) {
      var z = demo.querySelector('.os-phone__view.is-on [data-tap="' + name + '"]');
      if (z && z.getBoundingClientRect().width > 0) return z;
      await warte(60);
    }
    return null;
  }
  async function tippe(name) {
    var ziel = await hole(name);
    if (!ziel) return false;
    var p = phone.getBoundingClientRect(), z = ziel.getBoundingClientRect();
    if (hand && hand.naturalWidth) {
      var hw = hand.offsetWidth || p.width, hh = hw * hand.naturalHeight / hand.naturalWidth;
      hand.classList.add('is-on');
      setze(z.left + z.width * .62 - p.left - hw * TIP.x, z.top + z.height * .55 - p.top - hh * TIP.y);
      await warte(820);                          // ruhige Fahrt zum Ziel
      hand.classList.add('is-press');
      await warte(150);
    }
    ziel.classList.add('is-tapped');
    if (ziel.hasAttribute('data-pick')) ziel.classList.add('is-picked');
    await warte(220);
    ziel.classList.remove('is-tapped');
    if (hand) hand.classList.remove('is-press');
    await warte(240);
    return true;
  }

  var lauf = 0;
  async function durchlauf() {
    var ich = ++lauf;
    while (ich === lauf) {
      demo.querySelectorAll('.is-picked').forEach(function (el) { el.classList.remove('is-picked'); });
      sek.textContent = '20';
      zeige('start', -1);
      ruhe();
      await warte(1400); if (ich !== lauf) return;

      if (!(await tippe('start'))) { await warte(800); continue; }
      zeige('frage', 0); await warte(520);
      await tippe('antwort'); await warte(320);
      await tippe('weiter');
      zeige('uebung', 1);
      ruhe();                                     // während der Übung wartet die Hand unten, sie verschwindet nicht
      for (var n = 20; n >= 0; n -= 2) { if (ich !== lauf) return; sek.textContent = n; await warte(150); }
      await tippe('geschafft');
      zeige('auswertung', 1);
      ruhe();
      await warte(1100); zeige('ergebnis', 2);
      await warte(6200);
    }
  }
  var gestartet = false;
  function pruefe() {
    var r = phone.getBoundingClientRect();
    if (!gestartet && r.top < window.innerHeight * .75 && r.bottom > window.innerHeight * .25) { gestartet = true; durchlauf(); }
  }
  window.addEventListener('scroll', pruefe, { passive: true });
  window.addEventListener('resize', function () { if (gestartet) ruhe(); });
  zeige('start', -1); pruefe();
})();

/* Gründer-Film: drei kurze Szenen + das echte Teamfoto, weich überblendet; startet, sobald er im Blick ist */
(function () {
  var film = document.querySelector('[data-film]');
  if (!film) return;
  var szenen = Array.prototype.slice.call(film.querySelectorAll('[data-film-szene]')), balken = film.querySelectorAll('.os-film__bar i'), i = -1, laeuft = false, FOTO = 4500;
  if (document.documentElement.classList.contains('no-motion')) { szenen.forEach(function (s, n) { s.classList.toggle('is-on', n === szenen.length - 1); }); return; }
  function zeige(n) {
    i = n % szenen.length;
    if (i === 0) balken.forEach(function (b) { b.style.setProperty('--p', 0); });
    szenen.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
    var v = szenen[i].querySelector('video');
    if (v) { v._weiter = false; v.load(); v.play().catch(function () {}); }
    else { var t0 = performance.now(); (function tick() { var p = Math.min(1, (performance.now() - t0) / FOTO); balken[i].style.setProperty('--p', p.toFixed(3)); if (p < 1 && szenen[i] && !szenen[i].querySelector('video')) requestAnimationFrame(tick); })(); window.setTimeout(function () { zeige(i + 1); }, FOTO); }
  }
  szenen.forEach(function (s, k) {
    var v = s.querySelector('video'); if (!v) return;
    v.addEventListener('timeupdate', function () { if (!v.duration) return; balken[k].style.setProperty('--p', Math.min(1, v.currentTime / v.duration).toFixed(3)); if (!v._weiter && v.duration - v.currentTime < .7) { v._weiter = true; zeige(k + 1); } });
    v.addEventListener('ended', function () { if (!v._weiter) { v._weiter = true; zeige(k + 1); } });
  });
  function pruefe() { var r = film.getBoundingClientRect(); if (!laeuft && r.top < window.innerHeight * .8 && r.bottom > window.innerHeight * .2) { laeuft = true; zeige(0); } }
  window.addEventListener('scroll', pruefe, { passive: true }); pruefe();
})();
